
/**
 * --- External Imports ---
 */
import { faAngleRight } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, styled } from '@mui/material';
import { red } from '@mui/material/colors';
import { FormErrors } from '@ngt/forms-core';
import { FC, useContext, useState } from 'react';

/**
 * --- Internal Imports ---
 */
import AuthContext from '../../../contexts/auth/AuthContext';

/**
 * --- Styled Components ---
 */
const StyledAccordion = styled(Accordion)(({ theme }) => ({
    borderRadius: '15px',
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: '0 !important'
    }
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    backgroundColor: red[900],
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)'
    },
    '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0',
        marginLeft: theme.spacing(1)
    },
    '&.Mui-expanded': {
        minHeight: '0px'
    }
}));

/**
 * --- Custom NGT Form Values ---
 */
interface ICustomFormErrorsProps {
    roles?: string[];
}

const CustomFormErrors: FC<ICustomFormErrorsProps> = ({
    roles
}) => {
    const { user } = useContext(AuthContext);

    const [open, setOpen] = useState<boolean>(false);

    if (roles && !user?.roles?.find(x => roles.includes(x))) {
        return null;
    }

    return (
        <StyledAccordion
            expanded={open}
            onClick={() => setOpen(c => !c)}
        >
            <StyledAccordionSummary
                expandIcon={<FontAwesomeIcon color='white' icon={faAngleRight} />}
            >
                <Typography color='white' fontWeight='600'>Form Errors - Debug</Typography>
            </StyledAccordionSummary>
            <AccordionDetails
                sx={{
                    backgroundColor: red[100],
                    border: `3px solid ${red[900]}`
                }}
            >
                <Box>
                    <FormErrors />
                </Box>
            </AccordionDetails>
        </StyledAccordion>
    );
}

export default CustomFormErrors